module.exports = __webpack_public_path__ + "media/packs/site/assets/images/fr/fr_section03_img01-4405d8eb26c882cb84b8556ca105236a.png";